if (!customElements.get('cb-faq-chat')) {
  customElements.define('cb-faq-chat', class extends HTMLElement {
    connectedCallback() {
      const chatBtn = this.querySelector('[data-cb-fc-chat]');
      if (chatBtn && window.cbHasChat()) {
        chatBtn.hidden = false;
        chatBtn.addEventListener('click', () => window.cbOpenChat());
      }
      this.items = [...this.querySelectorAll('.cb-fc__item')].map((d) => ({
        q: d.querySelector('summary').textContent.trim(),
        html: d.querySelector('.cb-fc__answer').innerHTML
      }));
      if (!this.items.length) return;
      this.chat = this.querySelector('.cb-fc__chat');
      this.log = this.querySelector('[data-cb-fc-log]');
      this.trigger = this.querySelector('[data-cb-fc-input]');
      this.pop = this.querySelector('[data-cb-fc-pop]');
      this.typer = this.querySelector('[data-cb-fc-typer]');
      this.qs = [...this.querySelectorAll('[data-cb-fc-q]')];
      this.asked = new Set();
      this.still = matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.desk = matchMedia('(min-width: 960px)').matches;
      this.dataset.ready = '';

      this.qs.forEach((b) => b.addEventListener('click', () => this.ask(+b.dataset.cbFcQ)));
      this.trigger.addEventListener('click', () => (this.pop.hidden ? this.open() : this.close()));
      this.pop.addEventListener('click', (e) => {
        const o = e.target.closest('[data-i]');
        if (o) { this.close(); this.ask(+o.dataset.i); }
      });
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.pop.hidden) { this.close(); this.trigger.focus(); }
      });
      this.onOutside = (e) => { if (!this.pop.hidden && !this.querySelector('.cb-fc__bar').contains(e.target)) this.close(); };
      document.addEventListener('click', this.onOutside);

      this.say(this.desk ? this.dataset.greetDesk : this.dataset.greetPhone);
      if (this.desk) this.ask(0, true);
      else this.startTyper();

      this.onSelect = (e) => {
        const k = [...this.querySelectorAll('.cb-fc__item')].indexOf(e.target);
        if (k > -1) this.ask(k, true);
      };
      document.addEventListener('shopify:block:select', this.onSelect);
    }

    disconnectedCallback() {
      clearTimeout(this.t);
      clearTimeout(this.tLog);
      clearInterval(this.tick);
      if (this.io) this.io.disconnect();
      document.removeEventListener('click', this.onOutside);
      document.removeEventListener('shopify:block:select', this.onSelect);
    }

    bubble(cls, html, anchor) {
      const el = document.createElement('div');
      el.className = 'cb-fc__msg ' + cls;
      el.innerHTML = html;
      this.log.append(el);
      while (this.log.children.length > 9) this.log.firstElementChild.remove();
      // Long answers are read from the start: bring the question to the top
      if (this.desk) {
        const top = anchor ? anchor.offsetTop - 12 : this.log.scrollHeight;
        clearTimeout(this.tLog);
        const go = () => {
          this.log.scrollTo({ top: top, behavior: this.still ? 'auto' : 'smooth' });
          this.log.classList.toggle('is-cut', Math.min(top, this.log.scrollHeight - this.log.clientHeight) > 0);
        };
        // Grow past 640px when the question and its answer don't fit
        const h = anchor ? Math.max(640, el.offsetTop + el.offsetHeight - top + 24) : 0;
        if (h && h < this.log.clientHeight && !this.still) {
          // Shrinking clamps the scroll, so scroll once the height settles
          this.log.style.height = h + 'px';
          this.tLog = setTimeout(go, 420);
        } else {
          if (h) this.log.style.height = h + 'px';
          go();
        }
      } else if (anchor) {
        this.pageTo(anchor);
      }
      return el;
    }

    say(text) {
      if (!text) return;
      const p = document.createElement('p');
      p.textContent = text;
      this.bubble('cb-fc__msg--shop', p.outerHTML);
    }

    ask(i, now) {
      if (this.busy || !this.items[i]) return;
      const it = this.items[i];
      // Phone: no inner scroll, so keep only the current question
      if (!this.desk) this.log.innerHTML = '';
      const you = this.bubble('cb-fc__msg--you', '');
      you.textContent = it.q;
      this.asked.add(i);
      this.qs.forEach((b, k) => {
        b.classList.toggle('is-asked', this.asked.has(k));
        b.setAttribute('aria-pressed', k === i);
      });
      this.chat.classList.add('has-answer');
      if (now || this.still) { this.bubble('cb-fc__msg--shop', it.html, you); return; }
      this.busy = true;
      const wait = this.bubble('cb-fc__msg--shop', '<span class="cb-fc__dots" role="img" aria-label="Typing"><span></span><span></span><span></span></span>');
      this.t = setTimeout(() => {
        wait.remove();
        this.bubble('cb-fc__msg--shop', it.html, you);
        this.busy = false;
      }, 900);
    }

    // Scrolls the page so el sits just below the sticky header
    pageTo(el) {
      const head = document.querySelector('.header__outer-wrapper, header');
      const off = head ? Math.max(0, head.getBoundingClientRect().bottom) : 0;
      const y = el.getBoundingClientRect().top + window.scrollY - off - 12;
      window.scrollTo({ top: y, behavior: this.still ? 'auto' : 'smooth' });
    }

    open() {
      this.pop.innerHTML = '';
      this.items.forEach((it, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'cb-fc__opt' + (this.asked.has(i) ? ' is-asked' : '');
        b.dataset.i = i;
        b.textContent = it.q;
        this.pop.append(b);
      });
      this.pop.hidden = false;
      this.pop.scrollTop = 0;
      this.chat.classList.add('is-open');
      this.trigger.classList.remove('is-glow');
      this.trigger.setAttribute('aria-expanded', 'true');
      const r = this.chat.getBoundingClientRect();
      if (r.top < 80 || r.bottom > window.innerHeight) this.pageTo(this.chat);
      this.typer.classList.add('is-still');
      this.typer.textContent = 'Choose a question';
    }

    close() {
      this.pop.hidden = true;
      this.chat.classList.remove('is-open');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.typer.classList.remove('is-still');
      if (this.still) this.typer.textContent = this.items[0].q;
    }

    startTyper() {
      if (this.still) { this.typer.textContent = this.items[0].q; return; }
      let n = 0, c = 0, dir = 1, hold = 0;
      const step = () => {
        if (!this.pop.hidden || document.hidden) return;
        if (hold > 0) { hold--; return; }
        const w = this.items[n].q;
        c += dir;
        if (c >= w.length) { dir = -1; hold = 22; }
        if (c <= 0) { dir = 1; n = (n + 1) % this.items.length; hold = 4; }
        this.typer.textContent = w.slice(0, Math.max(0, c));
      };
      // The 55 ms timer runs only while the block is on screen
      this.io = new IntersectionObserver(([e]) => {
        if (e.isIntersecting && !this.tick) this.tick = setInterval(step, 55);
        else if (!e.isIntersecting && this.tick) { clearInterval(this.tick); this.tick = 0; }
      }, { threshold: 0.2 });
      this.io.observe(this);
    }
  });
}
